// Shared AEO (AI citation-readiness) display logic — the breakdown shape and
// grade thresholds must match backend/services/scoring_service.py exactly,
// since both article detail and commercial-page panels render the same
// server-computed `aeo_breakdown`.

export function gradeColor(grade) {
  return grade === "strong" ? "#008A33"
    : grade === "moderate" ? "#FF8C00"
    : grade === "weak" ? "#E67E22"
    : "#FF2A00";
}

// tip: copywriting guidance for a marketer editing this specific factor,
// grounded in what compute_citation_score() actually measures.
export const AEO_FACTORS = [
  {
    key: "answer_near_top",
    label: "Answer near top",
    max: 20,
    tip: "Open with a direct 1-2 sentence answer to the main question — don't bury it under intro/context.",
  },
  {
    key: "explicit_phrasing",
    label: "Explicit phrasing",
    max: 20,
    tip: "Use direct definition language (\"X means...\", \"this means...\", \"in other words...\") right where you make a key claim.",
  },
  {
    key: "factually_specific",
    label: "Factually specific",
    max: 20,
    tip: "Add concrete numbers, dates, or percentages — vague claims are less likely to get cited.",
  },
  {
    key: "self_contained",
    label: "Self-contained",
    max: 20,
    tip: "Break long paragraphs into standalone ~30+ word passages that each fully answer one point on their own.",
  },
  {
    key: "cites_sources",
    label: "Cites sources",
    max: 20,
    tip: "Reference a study, report, or named source — AI engines favor content that shows where its facts come from.",
  },
];

// Factors scoring below `threshold` (out of `max`), weakest first — the
// concrete copywriting to-do list for whoever is editing this content.
export function citationGaps(breakdown, threshold = 14) {
  if (!breakdown) return [];
  return AEO_FACTORS
    .map((f) => ({ ...f, score: breakdown[f.key] ?? 0 }))
    .filter((f) => f.score < threshold)
    .sort((a, b) => a.score - b.score);
}
